import React, { useState } from "react";
import Axios from "axios";
import WeatherInfo from "./weatherInfo";
import WeatherForecast from "./WeatherForecast";
import "./Weather.css";

export default function Weather(props) {
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);

  function search() {
    const urlRoot = "https://api.shecodes.io/weather/v1/current?";
    const apiKey = "84c6e0b933fac71ce8f9a33t197o5bd2";
    const units = "metric";
    let url = `${urlRoot}query=${city}&key=${apiKey}&units=${units}`;
    console.log(url);
    Axios.get(url).then(handleResponse);
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function handleCityChange(event) {
    setCity(event.target.value);
  }

  function handleResponse(response) {
    console.log(response.data);
    setWeatherData({
      ready: true,
      coordinates: response.data.coordinates,
      temperature: response.data.temperature.current,
      humidity: response.data.temperature.humidity,
      date: new Date(response.data.time * 1000),
      description: response.data.condition.description,
      icon: response.data.condition.icon_url,
      wind: response.data.wind.speed,
      city: response.data.city,
    });
  }
  if (weatherData.ready) {
    return (
      <div className="Weather p-5 my-0 mt-3">
        <div className="container">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-9">
                <input
                  type="search"
                  className="form-control search-input"
                  placeholder="Enter a City"
                  onChange={handleCityChange}
                />
              </div>
              <div className="col-3 p-0">
                <input type="submit" className="btn btn-primary w-100" />
              </div>
            </div>
          </form>
          <WeatherInfo data={weatherData} />
        </div>
        <WeatherForecast data={weatherData} />
      </div>
    );
  } else {
    search();
    return "Loading";
  }
}
